import React from 'react';
import { getAltKey, getCommandKey } from '@/utils/global';

import ArrowLeft from '@/components/Icons/icons/ArrowLeft';
import ArrowRight from '@/components/Icons/icons/ArrowRight';
import Electricity from '@/components/Icons/icons/Electricity';
import MarkAsUnread from '@/components/Icons/icons/EmailEditor/MarkAsUnread';
import EnterKeyIcon from '@/components/Icons/icons/EnterKeyIcon';
import ShippingBus from '@/components/Icons/icons/ShippingBus';
import AffiliateLinkTag from '@/components/Icons/icons/Shortcuts/AffiliateLinkTag';
import DiscountTag from '@/components/Icons/icons/Shortcuts/DiscountTag';
import DMTag from '@/components/Icons/icons/Shortcuts/DMTag';
import MultiSelectIcon from '@/components/Icons/icons/Shortcuts/MultiSelectIcon';
import NoteTag from '@/components/Icons/icons/Shortcuts/NoteTag';
import PostsIcon from '@/components/Icons/icons/Shortcuts/PostsIcon';
import TagIcon from '@/components/Icons/icons/Shortcuts/TagIcon';
import TasksIcon from '@/components/Icons/icons/Shortcuts/TasksIcon';

const commandKey = getCommandKey();
const altKey = getAltKey();
export const inboxShortcuts = [
  {
    title: 'Open first Unread Email',
    keys: ['O'],
  },
  {
    title: 'Unread Only',
    keys: ['U'],
  },
  {
    title: 'Ship Products',
    keys: ['S'],
  },
  {
    title: 'Quick Actions',
    keys: ['Q'],
  },
  {
    title: 'Exit to Main',
    keys: ['E'],
  },
  {
    title: 'Compose Email',
    keys: ['C'],
  },
  {
    title: 'Reply',
    keys: ['R'],
  },
  {
    title: 'Exit from Actions',
    keys: ['Esc'],
  },
  {
    title: 'Launch Filters',
    keys: ['F'],
  },
  {
    title: 'Clear Filters',
    keys: ['X'],
  },
  {
    title: 'Move between Emails',
    keys: [<ArrowLeft key="left" />, <ArrowRight key="right" />],
  },
  {
    title: 'Send Email',
    keys: [commandKey, <EnterKeyIcon key="right" />],
  },
  {
    title: 'Update Relationship Stage',
    keys: [commandKey, 'U'],
  },
  {
    title: 'Generate Affiliate Link',
    keys: [commandKey, 'A'],
  },
  {
    title: 'Generate Discount Code',
    keys: [commandKey, 'D'],
  },
  {
    title: 'Add Tags',
    keys: [altKey, 'T'],
  },
  {
    title: 'Take a Note',
    keys: [altKey, 'N'],
  },
  {
    title: 'Shortcuts Table',
    keys: [commandKey, 'K'],
  },
  {
    title: 'Type Template Name',
    keys: ['/'],
  },
  {
    title: 'Snippets',
    keys: ['{'],
  },
];

export const profileShortcuts = [
  {
    icon: <ShippingBus color="var(--icon-subdued)" />,
    title: 'Ship Products',
    keys: ['S'],
  },
  {
    icon: <DiscountTag color="var(--icon-subdued)" />,
    title: 'Generate Discount',
    keys: ['D'],
  },
  {
    icon: <AffiliateLinkTag color="var(--icon-subdued)" />,
    title: 'Generate Affiliate Link',
    keys: ['L'],
  },
  {
    icon: <TagIcon color="var(--icon-subdued)" />,
    title: 'Add Tag',
    keys: ['T'],
  },
  {
    icon: <NoteTag color="var(--icon-subdued)" />,
    title: 'Add Note',
    keys: ['N'],
  },
  {
    icon: <DMTag color="var(--icon-subdued)" />,
    title: 'Send DM',
    keys: ['M'],
  },
  {
    icon: <MarkAsUnread color="var(--icon-subdued)" />,
    title: 'Add to Email Drip',
    keys: ['E'],
  },
  {
    icon: <PostsIcon color="var(--icon-subdued)" />,
    title: 'Log a Post',
    keys: ['P'],
  },
  {
    icon: <TasksIcon color="var(--icon-subdued)" />,
    title: 'Add a Task',
    keys: ['K'],
  },
  {
    icon: <Electricity width={20} height={20} color="var(--icon-subdued)" />,
    title: 'Show Shortcuts Table',
    keys: [commandKey, 'K'],
  },
];

export const relationshipShortcuts = [
  {
    icon: <MultiSelectIcon width={20} height={20} color="var(--icon-subdued)" />,
    title: 'Multi-select Cards',
    keys: [commandKey, 'Click'],
  },
  {
    icon: <Electricity width={20} height={20} color="var(--icon-subdued)" />,
    title: 'Shortcuts Table',
    keys: [commandKey, 'K'],
  },
];
